
import {Component, Prop, Vue} from 'vue-property-decorator';
import {appIcon} from '@/shared/document.icon';
import SbToolbarBtn from '@/components/stead/workspaces/stepbuilder/sbToolbarBtn.vue';
import {eRunStatus} from '@/store/stead/runner.store';
import {Location} from 'vue-router';
import {createPassport} from '@/shared/local.storage.utils';
import SbSelectRushDialog from "@/components/stead/workspaces/stepbuilder/dialogboxes/sbSelectRushDialog.vue";

@Component({
  components: {SbSelectRushDialog, SbToolbarBtn}
})
export default class sbToolbar extends Vue {
  // Les props
  @Prop() private testname!: string
  @Prop() private testid!: string
  @Prop({default: false}) private connected!: boolean
  @Prop({default: false}) private range!: boolean
  @Prop({default: 0}) private nbStepsInBuffer!: number
  @Prop({default: true}) private debug!: boolean


  // Les propriétés
  private mdi = appIcon

  // Les propriétés calculées
  private get toolbarColor() {
    return this.$store.state.testcase.theme.tree.doc1
  }

  private get paste() {
    return this.nbStepsInBuffer > 0
  }

  private get isInitState() {
    return this.$store.state.runner.runStatus === eRunStatus.INIT
  }

  private get to(): Location {
    if (this.$store.state.current.Project) {
      const prjid = this.$store.state.current.Project._id
      const passport = createPassport(prjid, this.testid)
      return {name: 'testcase.workspace', params: {passport}}
    } else {
      return {name: 'testcase.workspace'}
    }
  }

  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  // Les méthodes statiques
}
